import React, { useState } from "react";
import _ from "lodash";
import {
  createStyles,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  Grid,
  makeStyles,
  Typography,
} from "@material-ui/core";
import "jspdf-autotable";

import { CustomTheme } from "../../../../types/customTheme";
import DialogCommonDefault from "../../../../components/dialogs/DialogCommonDefault";
import TextfieldDefaultNew from "../../../../components/textField/TextfieldDefaultNew";
import ValidationMessage from "../../../../components/validation/ValidationMessage";
import ButtonCommon from "../../../../components/buttons/ButtonCommon";
import SwitchCommon from "../../../../components/switches/SwitchCommon";
import AvailabilitySelection from "../../../../components/time/AvailabilitySelection";
import {
  combineMinuteOfWeekArrays,
  normalizeTimeSelections,
} from "../../../../utils/time-conversions";
import { areObjectArraysEqual } from "../../../../utils/isDeepEqual";
import {
  ERROR_MESSAGE_UPDATING_ERROR,
  ERROR_MESSAGE_VERSION_ERROR,
  SUCCESSFULLY_UPDATED,
} from "../../../../utils/consts";
import { AxiosError } from "axios";
import { HttpStatus } from "../../../../utils/enum";
import { updateAvailabilityBannerInfo } from "../../../../services/customerApp/customerDetails";
import { useRouteMatch } from "react-router-dom";
import BannerAvailability from "./BannerAvailability";

export interface CustomerNodeProps {
  isOpen: any;
  setIsOpen: any;
  isEdit: any;
  handleReset: any;
  isLoadingButton: any;
  handleSubmitData: any;
  title: any;
  subTitle: any;
  description: any;
  img: any;
  isError: any;
  setIsError: any;
  setTitle: any;
  setSubTitle: any;
  setDescription: any;
  setImg: any;
  setIsStatus: any;
  isStatus: any;
  setOrder: any;
  order: any;
  setSuccess: any;
  setError: any;
  setOriginalNodeData: any;
  originalNodeData: any;
  availabilityError: any;
  bannerId: any;
  bannerList: any;
  setBannerList: any;
}

const useStyles = makeStyles((theme: CustomTheme) => createStyles({}));

const BannerCreateAndUpdateModal: React.FunctionComponent<
  CustomerNodeProps
> = ({
  isOpen,
  setIsOpen,
  isEdit,
  handleReset,
  isLoadingButton,
  handleSubmitData,
  title,
  subTitle,
  description,
  img,
  isError,
  setIsError,
  setTitle,
  setSubTitle,
  setDescription,
  setImg,
  setIsStatus,
  isStatus,
  setOrder,
  order,
  setSuccess,
  setError,
  setOriginalNodeData,
  originalNodeData,
  availabilityError,
  bannerId,
  bannerList,
  setBannerList,
}) => {
  const match: any = useRouteMatch();
  const handleChangeStatus = () => {
    setIsStatus(!isStatus);
  };
  const [availabilityErrorMessage, setAvailabilityErrorMessage] =
    useState(false);

  /* Send an API call to after click availability apply button. 
    An API call is sent only if the status is not "create". */
  const handleSubmitAvailability = async (
    availabilitySelectionList: Array<any>,
  ) => {
    setAvailabilityErrorMessage(false);
    try {
      /* availabilitySelectionList = [{openTime: '11:49', closeTime: '11:49', id: 2, 
                                           nodeList: [{minuteOfWeek: 3589, durationMins: 1440, day: 'tue', openTime: '11:49', closeTime: '11:49'},
                                                      {minuteOfWeek: 6469, durationMins: 1440, day: 'thu', openTime: '11:49', closeTime: '11:49'}]}]
             combinedMowArrays = {tue: [{minuteOfWeek: 3589, durationMins: 1440, day: 'tue', openTime: '11:49', closeTime: '11:49'},
                                  thu:  {minuteOfWeek: 6469, durationMins: 1440, day: 'thu', openTime: '11:49', closeTime: '11:49'}]} */
      const combinedMowArrays: any = combineMinuteOfWeekArrays(
        availabilitySelectionList,
      );
      let normalizedArray = _.cloneDeep(combinedMowArrays);

      // Remove select same date range in same same date.
      Object.keys(combinedMowArrays).forEach((day) => {
        normalizedArray[day] = normalizeTimeSelections(normalizedArray[day]);
      });

      // Convert array to minute of week array
      const mowArray: any = Object.values(normalizedArray).flat();
      const data = _.cloneDeep(originalNodeData);

      // Update data
      data.availability = mowArray;
      let message = "";
      let body = {};
      let summaryString = "";
      if (
        !areObjectArraysEqual(data.availability, originalNodeData.availability)
      ) {
        summaryString =
          "Availability changed from `" +
          JSON.stringify(originalNodeData.availability) +
          "` to `" +
          JSON.stringify(data.availability) +
          "`";
        message = "Eatpresto Delivery Information Changed";
        body = {
          message,
          summary: summaryString,
          type: "delivery_info",
          code: "update",
          access_type: true,
          metadata: { changedBy: "" },
        };
      }
      // If the discount has been created, add new 'availability'.
      const res = await updateAvailabilityBannerInfo(
        match.params.locationId,
        bannerId,
        data,
        body,
        "eatpresto",
      );
      const { availability: resAvailability } = res.data.data;
      const cloneBannerList = _.cloneDeep(bannerList);
      cloneBannerList.map((data: any) => {
        if (data.bannerId === bannerId) {
          data["availability"] = resAvailability;
        }
      });
      setOriginalNodeData({ availability: data.availability });
      setBannerList(cloneBannerList);
      // getDeliveryInfo();
      setSuccess(SUCCESSFULLY_UPDATED);
    } catch (error) {
      const err: any = error as AxiosError;
      if (err.response.status === HttpStatus.CONFLICT_409) {
        setError(ERROR_MESSAGE_VERSION_ERROR);
        // getDeliveryInfo();
      } else {
        setError(ERROR_MESSAGE_UPDATING_ERROR);
      }
    }
  };

  const handleDisable = () => {};
  return (
    <>
      <DialogCommonDefault
        open={isOpen}
        setOpen={setIsOpen}
        isNeedFixedHeight={false}
      >
        <DialogTitle>Add New Banner</DialogTitle>
        <DialogContent>
          <Grid container>
            <Grid item xs={12}>
              <Typography style={{ fontWeight: "bold" }}>Title</Typography>

              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <TextfieldDefaultNew
                  id="title"
                  name="title"
                  type="text"
                  value={title}
                  onChange={(e: any) => {
                    setTitle(e.target.value);
                    setIsError(false);
                  }}
                />

                <FormControlLabel
                  style={{ marginRight: "0px" }}
                  control={<SwitchCommon />}
                  checked={isStatus}
                  onChange={handleChangeStatus}
                  label="Status"
                  labelPlacement="start"
                />
              </div>
              {!title && isError ? (
                <ValidationMessage message={"Title is required"} />
              ) : (
                ""
              )}
            </Grid>

            <Grid item xs={12}>
              <Typography style={{ fontWeight: "bold" }}>Sub Title</Typography>
              <div style={{ display: "flex" }}>
                <TextfieldDefaultNew
                  id="subTitle"
                  name="subTitle"
                  type="text"
                  value={subTitle}
                  onChange={(e: any) => setSubTitle(e.target.value)}
                />
              </div>
            </Grid>

            <Grid item xs={12}>
              <Typography style={{ fontWeight: "bold" }}>
                Description
              </Typography>
              <div style={{ display: "flex" }}>
                <TextfieldDefaultNew
                  id="description"
                  name="description"
                  type="text"
                  value={description}
                  onChange={(e: any) => setDescription(e.target.value)}
                />
              </div>
            </Grid>

            <Grid item xs={12}>
              <Typography style={{ fontWeight: "bold" }}>Img</Typography>
              <div style={{ display: "flex" }}>
                <TextfieldDefaultNew
                  id="img"
                  name="img"
                  type="text"
                  value={img}
                  onChange={(e: any) => setImg(e.target.value)}
                />
              </div>
            </Grid>
            {/* <Grid item xs={12}>
              <Typography style={{ fontWeight: "bold" }}>Order</Typography>
              <div style={{ display: "flex" }}>
                <TextfieldDefaultNew
                  id="order"
                  name="order"
                  type="number"
                  value={order}
                  onChange={(e: any) =>
                    e.target.value >= 0 && setOrder(e.target.value)
                  }
                />
              </div>
            </Grid> */}
            <BannerAvailability
              originalNodeData={originalNodeData}
              handleSubmitAvailability={handleSubmitAvailability}
              setAvailabilityErrorMessage={setAvailabilityErrorMessage}
            />
          </Grid>
        </DialogContent>
        <DialogActions style={{ marginBottom: "8px" }}>
          <ButtonCommon
            variant="contained"
            style={{ fontSize: 11, width: "100px", marginRight: 8 }}
            color="yellow"
            onClick={handleReset}
          >
            Cancel
          </ButtonCommon>
          <ButtonCommon
            variant="contained"
            style={{
              fontSize: 11,
              marginLeft: 4,
              width: "100px",
            }}
            disabled={handleDisable()}
            isLoadingPage={isLoadingButton}
            color={isEdit ? "orange" : "green"}
            onClick={handleSubmitData}
          >
            {isEdit ? "Save" : "Create"}
          </ButtonCommon>
        </DialogActions>
      </DialogCommonDefault>
    </>
  );
};

export default BannerCreateAndUpdateModal;
